import { render, staticRenderFns } from "./FacilitySettings.vue?vue&type=template&id=64f023c6"
import script from "./FacilitySettings.ts?vue&type=script&lang=ts&external"
export * from "./FacilitySettings.ts?vue&type=script&lang=ts&external"
import style0 from "./FacilitySettings.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports